import { createUpsell } from '../upsell';
export const APV6m8 = createUpsell({
    id: 'APV6m8',
    desc: `Upsell sequence MuscleCharge - UK/JOIN/EU`,
    seq: [
        {
            id: 'upsell-coach',
            onPurchase: ['upsell-meal-plan-supplements-guide'],
            onDecline: [
                'upsell-12-month-muscle-charge',
                'upsell-chair-workout-six-pack',
                'upsell-meal-plan-supplements-guide',
            ],
        },
    ],
});
